/* @flow */
import moment from 'moment';
import 'moment/locale/pt-br';
import dateRangePickerComOpcoes from './date-range-picker-com-opcoes';

const dateRangePicker = (callback: Function) => {
    const opcoes = {
        id: '#m_dashboard_daterangepicker',
        dataInicial: moment().format('Y-MM-D'),
        dataFinal: moment().format('Y-MM-D'),
        callback,
    };

    dateRangePickerComOpcoes(opcoes);
};

export default dateRangePicker;
